import general from './general.json';
import legalWarning from './legalWarning.json';

export default {
	general: general,
	legalWarning: legalWarning
};
